import React, { useEffect, useState } from "react";
import { USER_LIST_COLUMNS } from "../../columns/admin-columns";
import { Button, Card, CardContent, Grid } from "@mui/material";
import { toast } from "react-toastify";
import AlertDialog from "../../components/AlertDialog";
import BasicTable from "../../components/table/BasicTable";
import { userDetailsUpdate } from "../../schema/form";
import {
  deleteUser,
  getUserList,
  updateUser,
} from "../../services/dataService";
import EditModalDialog from "../../components/EditModalDialog";
import { getUser } from "../../services/authService";
import { ReactComponent as AmmountError } from "../../assets/svg/todo.svg";

function UserList() {
  const [users, setUsers] = useState([]);
  const [userUpdate, setUserUpdate] = useState(null);
  const [open, setOpen] = useState(null);
  const user = getUser();

  useEffect(() => {
    async function requestUserList() {
      try {
        const response = await getUserList();
        setUsers(response.data);
      } catch (error) {
        toast.error("No user found");
      }
    }
    requestUserList();
  }, []);

  const handleAlertClose = () => {
    setOpen(null);
  };

  const handleEditClose = () => {
    setUserUpdate(null);
  };

  const handleUpdate = (data) => {
    setUserUpdate(data);
  };

  const handleSubmit = async (data) => {
    const editUserPayload = new FormData();
    try {
      editUserPayload.append("UserId", data.UserId);
      editUserPayload.append("LoginId", data.LoginId);
      editUserPayload.append("FirstName", data.FirstName);
      editUserPayload.append("LastName", data.LastName);
      editUserPayload.append("Email", data.Email);
      editUserPayload.append("MobileNo", data.MobileNo);
      editUserPayload.append("DateOfBirth", data.DateOfBirth);
      editUserPayload.append("UserType", data.UserType);
      editUserPayload.append("GenderId", 1);
      editUserPayload.append("CountryId", 1);
      editUserPayload.append("StateId", 1);
      editUserPayload.append("CityId", 1);
      editUserPayload.append("HomeTownAddress", data.HomeTownAddress || "-");
      editUserPayload.append("Modified_By", user?.userDetails["UserId"]);
      editUserPayload.append("IsMfA", data.IsMFA);
      editUserPayload.append("MFADays", data.MFADays);

      await updateUser(editUserPayload);

      setUsers(
        users.map((item) => {
          if (item.UserId === data.UserId) {
            return {
              ...item,
              FirstName: data.FirstName,
              LastName: data.LastName,
              Email: data.Email,
              MobileNo: data.MobileNo,
              DateOfBirth: data.DateOfBirth,
              IsMFA:data.IsMFA,
              MFADays:data.MFADays,
            };
          }
          return item;
        })
      );
      setUserUpdate(null);
      toast.success("User updated Successfully");
    } catch (error) {
      var message = "";
      for (const field of Object.keys(data)) {
        if (error.response.data.errors[field]) {
          message = message + error.response.data.errors[field][0] + ", ";
        }
      }
      toast.error(message);
    }
  };

  const handleDelete = async (data) => {
    setOpen(data);
  };

  const userDelete = async (data) => {
    try {
      await deleteUser({
        MuserId: data.UserId,
        UserId: user?.userDetails["UserId"],
      });

      var filterData = [];
      for (const item of users) {
        if (item.UserId !== data.UserId) {
          filterData.push(item);
        }
      }
      setUsers(filterData);
      setOpen(null);
      toast.success("User has been deleted");
    } catch (error) {}
  };

  const getColumn = () => {
    if (
      user?.isImpexAdmin ||
      user?.isSupplierAdmin ||
      user?.isImpexAdmin
    ) {
      return [
        ...USER_LIST_COLUMNS,
        {
          Header: "UPDATE",
          accessor: "update",
          show: true,
        },
        {
          Header: "DELETE",
          accessor: "delete",
          show: true,
        },
      ];
    } else {
      return USER_LIST_COLUMNS;
    }
  };

  return (
    <>
      <EditModalDialog
        updateModal={userUpdate}
        handleClose={handleEditClose}
        dialogTitle="Update user details"
        formSchema={userDetailsUpdate}
        dialogActions="Submit"
        onEdit={handleSubmit}
      />
      <AlertDialog
        open={open}
        onClose={handleAlertClose}
        svgFile={<AmmountError style={{ maxWidth: 280, width: "100%" }} />}
        title={"Delete"}
        description={"Are you sure you want to delete this user?"}
        isAlert={false}
        onConfirm={userDelete}
      >
        <Button>Ok</Button>
        <Button>Cancel</Button>
      </AlertDialog>

      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Grid item md={12} lg={12} sm={12}>
          <Card>
            <CardContent>
              <BasicTable
                data={users}
                columns={getColumn()}
                onUpdate={handleUpdate}
                onDelete={handleDelete}
                pagination={true}
                tableFilter
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}

export default UserList;
